import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import ProfileSettings from './ProfileSettings';
import BusinessSettings from './BusinessSettings';
import ContactTagSettings from './ContactTagSettings';
import CustomFieldSettings from './CustomFieldSettings';

const { FiUser, FiBriefcase, FiTag, FiList } = FiIcons;

const Settings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  
  const tabs = [
    { id: 'profile', label: 'Profile', icon: FiUser },
    { id: 'business', label: 'Business', icon: FiBriefcase },
    { id: 'tags', label: 'Contact Tags', icon: FiTag },
    { id: 'fields', label: 'Custom Fields', icon: FiList }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'profile': return <ProfileSettings />;
      case 'business': return <BusinessSettings />;
      case 'tags': return <ContactTagSettings />;
      case 'fields': return <CustomFieldSettings />;
      default: return <ProfileSettings />;
    }
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-800">Settings</h1>
      
      <div className="flex flex-col lg:flex-row gap-6">
        <div className="lg:w-64 bg-white rounded-xl shadow-sm border border-gray-200 p-4 shrink-0">
          <nav className="space-y-2">
            {tabs.map((tab) => (
              <motion.button
                key={tab.id}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-all ${activeTab === tab.id ? 'bg-blue-50 text-blue-600 border-l-4 border-blue-600' : 'text-gray-600 hover:bg-gray-50'}`}
              >
                <SafeIcon icon={tab.icon} />
                <span className="font-medium">{tab.label}</span>
              </motion.button>
            ))}
          </nav>
        </div>

        <div className="flex-1">
          <motion.div key={activeTab} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3 }} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            {renderContent()}
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Settings;